'use client';

import {ModalBackdrop} from 'common/components/modal_backdrop';
import {Loader2} from 'lucide-react';
import {useEffect, useState} from 'react';

// Mirrors the five dimensions the grading model scores (see the platform_takehome_solution_grading
// prompt / TakehomeGradingResult): solution correctness, technical sense, code quality,
// business intuition, and communication.
const ANALYSIS_STEPS: Array<string> = [
  'Analyzing solution correctness…',
  'Reviewing your technical approach…',
  'Evaluating code quality…',
  'Assessing business intuition…',
  'Checking communication & clarity…',
];

const STEP_INTERVAL_MS = 2200;

// GradingProgressModal blocks the UI with a non-dismissible backdrop while a solution
// is being graded, cycling through the analysis steps so the wait feels purposeful.
export function GradingProgressModal() {
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setStepIndex((prev) => (prev + 1) % ANALYSIS_STEPS.length);
    }, STEP_INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <ModalBackdrop zIndex={50} aria-label='Grading your solution'>
      <div className='relative bg-white rounded-2xl shadow-2xl w-full max-w-sm p-8 flex flex-col items-center gap-5 text-center'>
        <Loader2 className='w-10 h-10 text-iq-red animate-spin' strokeWidth={1.75} />
        <div className='flex flex-col gap-1.5'>
          <h2 className='text-lg font-bold text-iq-black'>Grading your solution</h2>
          <p className='text-sm text-iq-grey-medium leading-relaxed'>
            Our AI is reviewing your take-home in depth. This can take up to a minute — please keep
            this tab open.
          </p>
        </div>
        <p className='text-sm font-semibold text-iq-black min-h-[1.25rem]' aria-live='polite'>
          {ANALYSIS_STEPS[stepIndex]}
        </p>
      </div>
    </ModalBackdrop>
  );
}
